import { render } from "./FlippingCard.vue?vue&type=template&id=6d251dfc"
import script from "./FlippingCard.vue?vue&type=script&lang=js"
export * from "./FlippingCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/FlippingCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d251dfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d251dfc', __exports__)) {
    api.reload('6d251dfc', __exports__)
  }
  
  module.hot.accept("./FlippingCard.vue?vue&type=template&id=6d251dfc", () => {
    api.rerender('6d251dfc', render)
  })

}


export default __exports__